export function stopPropagation(event: React.SyntheticEvent): void {
  event.stopPropagation();
}

export function scrollIntoView(element: Element | null): void {
  element?.scrollIntoView({
    inline: 'nearest',
    block: 'nearest',
    //  behavior: 'smooth'
  });
}

export function getCellToScroll(gridEl: HTMLDivElement): HTMLDivElement | null {
  return gridEl.querySelector<HTMLDivElement>(':scope > [role="row"] > [tabindex="0"]');
}

export function focusCellOrCellContent(gridEl: HTMLDivElement): void {
  const cell = getCellToScroll(gridEl);
  if (cell === null) return;

  scrollIntoView(cell);
  // Focus cell content when available instead of the cell itself
  const elementToFocus = cell.querySelector<Element & HTMLOrSVGElement>('[tabindex="0"]') ?? cell;
  // Works around modal dismissial refocus
  setTimeout(() => {
    elementToFocus.focus({ preventScroll: true });
  });
}
